// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { logout } from '@/authentication/api/logout';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return async () => {
    await logout();

    queryClient.clear();
    Sentry.setContext('authentication', {
      authenticated: false,
      lastError: null,
    });
    Sentry.setUser(null);

    await navigate({ to: '/login' });
  };
}
